import { useUserRoles } from '@anytag/auth';
import { MarketplaceCampaignDetailType } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { DefaultFormProps } from '../types';
import { getMarketplaceInitialFormValues } from '../utils';
import { getReferralCodeTrackingFormSchema } from './schema';
import { Template } from './Template';

export const ReferralCodeTrackingForm = ({ data, onSubmit, disabledFields, defaultAdvertiser }: DefaultFormProps) => {
  const { role } = useUserRoles();

  const defaultValues = getMarketplaceInitialFormValues({
    data,
    defaultAdvertiser,
    campaignType: MarketplaceCampaignDetailType.REFERRAL_CODE
  });

  return (
    <Form.Provider
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      zodSchema={getReferralCodeTrackingFormSchema(role)}
    >
      <Template defaultValues={defaultValues} disabledFields={disabledFields} />
    </Form.Provider>
  );
};
